<div class="section-container">
  <div class="section-header" *ngIf="title || headerLink">
    <div class="section-header-name">
      <h2 *ngIf="title">{{ title }}</h2>
      <div *ngIf="headerLink" class="section-header-link-container">
        <a [routerLink]="headerLink.path" class="section-header-link">{{
            headerLink.text
          }}</a>
      </div>
    </div>
    <div *ngIf="sectionIcon"
         class="section-header-icon"
         (click)="iconClicked.emit(sectionIcon)">
      <mat-icon>{{sectionIcon}}</mat-icon>
    </div>
  </div>
  <ng-content></ng-content>
</div>
